module.exports = __webpack_public_path__ + "static/media/productTypeSheet.e1116a10.svg";